import React, { useState } from "react";
import { Tabs } from "antd";
import TrackFoodDashboard from "../components/TrackFoodDashboard";
import TrackWeightsLineChart from "../components/TrackWeightsLineChart";
import CalorieTrackList from "../components/CalorieStats";
import DashboardRecipeRow from "../components/dashboard/DashboardRecipeRow";
import CalorieBar from "../components/dashboard/CalorieBar";

const { TabPane } = Tabs;

const Dashboard = () => {
  const [refreshSignal, setRefreshSignal] = useState(0);

  const handleNewItemTracked = () => {
    setRefreshSignal((c) => c + 1);
  };

  const isMobile = window.innerWidth <= 767; // or use a hook if you prefer

  if (isMobile) {
    // MOBILE: calories always on top, rest in tabs
    return (
      <div style={{ padding: 16 }}>
        <div style={{ marginBottom: 16 }}>
          <CalorieBar refreshSignal={refreshSignal} />  
        </div>

        <Tabs defaultActiveKey="track">
          <TabPane tab="Track Food" key="track">
            <TrackFoodDashboard onNewItemTrackedProp={handleNewItemTracked} />
          </TabPane>

          <TabPane tab="Recipes" key="recipes">
            <DashboardRecipeRow />
          </TabPane>

          <TabPane tab="Weight" key="weight">
            <TrackWeightsLineChart />
          </TabPane>
        </Tabs>
      </div>
    );
  }

  // DESKTOP: existing two-column layout
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        height: "100vh",
      }}
      className="dashboard-container"
    >
      {/* left column: food tracker */}
      <div
        style={{
          flexBasis: "33.33%",
          flexShrink: 0,
          height: "100vh",
          overflowY: "auto",
          borderRight: "1px solid #f0f0f0",
          boxSizing: "border-box",
          padding: 16,
        }}
        className="track-food-container"
      >
        <TrackFoodDashboard onNewItemTrackedProp={handleNewItemTracked} />
      </div>

      {/* right column: calories, recipes row, weight chart */}
      <div
        style={{
          flex: 1,
          height: "100vh",
          overflowY: "auto",
          padding: 16,
          display: "flex",
          flexDirection: "column",
        }}
        className="right-dash-container"
      >


        <div style={{ marginBottom: 24 }}>
          <CalorieBar refreshSignal={refreshSignal} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <DashboardRecipeRow />
        </div>

        <div className="weight-track">
          <TrackWeightsLineChart />
        </div>

                <div className="calorie-track" style={{ marginBottom: 16 }}>
          <CalorieTrackList refreshSignal={refreshSignal} />
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
